/**
 * Imports nothing, deliberately. `sectionPickerRuntime.ts` is bundled on its own into
 * `public/section-picker.js` and injected into the preview iframe, so anything it reaches must be
 * free of app-level dependencies — an i18n import or an `@/` alias here would break that build.
 */

/**
 * Whether the element's content has to be treated as raw markup rather than as text.
 *
 * Comments count. An element whose only non-text children are Outlook MSO conditionals still holds
 * markup, and escaping it as text deletes them — which the published email needs and the user cannot
 * see in the content field.
 *
 * Both producers of this flag call it — the runtime's click payload and `getElementSnapshot` — and
 * they have to agree: one decides what seeds the editing field, the other decides how the result is
 * written back. When they disagreed, an element read as text on the way in and was written back
 * escaped on the way out.
 */
export function hasMarkupChildren(element: Element): boolean {
  return Array.from(element.childNodes).some(
    (node) => node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.COMMENT_NODE,
  );
}
